import { MapSourceType } from '@caresend/types';

const mapSourcesFriendlyNames = {
    [MapSourceType.DRAFT_WAYPOINTS]: 'Waypoints',
    [MapSourceType.WAYPOINT]: 'Waypoints',
    [MapSourceType.PLACES]: 'Locations',
    [MapSourceType.SHIFTS]: 'Shifts',
    [MapSourceType.ITINERARY_ACTUAL_START_POINT]: 'Actual starting point',
    [MapSourceType.ITINERARY_INDICATED_START_POINT]: 'Indicated starting point',
    [MapSourceType.PATIENT]: 'Patient stop',
    [MapSourceType.PICK_DROP]: 'Pick up or drop off',
    [MapSourceType.CLINICIAN_LAST_LOCATION]: 'Clinician',
    [MapSourceType.ITINERARY_END_POINT]: 'Indicated exit point',
    [MapSourceType.USER_PHOTO]: '',
};
var MarkerIconName;
(function (MarkerIconName) {
    MarkerIconName["CLINICIAN"] = "clinician";
    MarkerIconName["ARRIVAL"] = "arrival";
    MarkerIconName["PLAY"] = "play";
    MarkerIconName["HOME"] = "home";
})(MarkerIconName || (MarkerIconName = {}));
({
    [MapSourceType.DRAFT_WAYPOINTS]: 'home',
    [MapSourceType.PLACES]: 'store',
    [MapSourceType.SHIFTS]: 'clock',
});
var DispatchView;
(function (DispatchView) {
    DispatchView["CREATE"] = "create";
    DispatchView["MANAGE"] = "manage";
})(DispatchView || (DispatchView = {}));

export { DispatchView, MarkerIconName, mapSourcesFriendlyNames };
